import React from "react";
import ReactMarkdown from "markdown-to-jsx";
import classNames from "classnames";

import { useUserData } from "lib/store/user";
import { PaywallData } from "lib/types/datoBlocks";

import Button from "../buttonNew/button";
import Modal from "../modalNew/modal";

type PaywallModalProps = PaywallData & {
  open: boolean;
  innerTestId?: string;
  onOpenChange: (open: boolean) => void;
  onLogin: () => void;
  onPrimaryButtonClick: () => void;
};

const PaywallModal = ({
  title,
  open,
  text,
  onOpenChange,
  loginButtonText,
  primaryCtaText,
  onLogin,
  onPrimaryButtonClick,
  innerTestId,
}: PaywallModalProps) => {
  const { readerSubscriptionLevel } = useUserData();

  return (
    <Modal
      isOpen={open}
      title={
        <span className={"font-recklessBold text-[24px] text-black-rock"}>
          {title}
        </span>
      }
      forceMount={false}
      innerClassNames={"w-[100vw] md:max-w-[460px] lg:w-[460px]"}
      contentClassNames={""}
      onOpenChange={onOpenChange}
      onOpenAutoFocus={(e) => {
        e.preventDefault();
        const target = e.target as HTMLDivElement | undefined;
        target?.focus();
      }}
    >
      <div
        className={"flex flex-col text-[16px] leading-[130%] text-mono-70"}
        data-testid={innerTestId}
      >
        <div className={"mb-5 flex flex-col gap-4"}>
          {text.map((renderBlock) => {
            if (
              renderBlock._modelApiKey !==
                "paywall_text_block_for_unregistered" ||
              (renderBlock._modelApiKey ===
                "paywall_text_block_for_unregistered" &&
                readerSubscriptionLevel === "unregistered")
            ) {
              return (
                <ReactMarkdown
                  key={renderBlock.id}
                  className={classNames(
                    "[&_p]:mb-[1.3em]",
                    "[&_a]:inline [&_a]:underline [&_a]:[text-underline-position:under]",
                    "focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring",
                    "[&_a]:text-pro-blue focus-visible:[&_a]:ring-pro-blue"
                  )}
                >
                  {renderBlock.text}
                </ReactMarkdown>
              );
            }

            return null;
          })}
        </div>
        <div className={"flex items-center justify-center gap-3"}>
          {readerSubscriptionLevel === "unregistered" && (
            <Button
              size={"medium"}
              colour={"navy"}
              buttonType={"secondary"}
              onClick={onLogin}
            >
              {loginButtonText}
            </Button>
          )}
          <Button
            size={"medium"}
            colour={"navy"}
            onClick={onPrimaryButtonClick}
          >
            {primaryCtaText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaywallModal;
